var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAthlete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 91,
    viewBox: "0 0 87 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2528 51.7411C72.3769 54.8059 67.4758 57.8328 62.5855 60.8723L50.6854 42.5143C50.5429 42.343 50.3913 42.2275 50.2434 42.085C47.4817 37.2993 44.4097 32.7319 41.1591 28.2854C47.8497 28.4892 54.5403 28.3756 61.2452 27.8037C68.7115 27.1688 68.7746 15.4544 61.2452 16.0948C50.3751 17.0202 39.5374 16.856 28.6799 15.8368C27.5994 15.7358 26.6939 15.9126 25.9272 16.2535C23.8239 16.5999 21.8162 17.5469 20.4272 18.9503C16.4352 22.9892 17.2632 28.4243 20.5102 32.4902C25.5177 38.7532 30.0906 45.3464 34.0645 52.3166C28.1045 54.0086 22.1445 55.7078 16.1845 57.3981C14.6079 57.8454 13.5472 58.7438 12.8852 59.8315C12.7175 60.0299 12.5425 60.2103 12.391 60.4412C7.94982 67.1715 4.00114 74.1615 0.680208 81.5195C-2.40081 88.3435 7.68825 94.3053 10.7909 87.4308C13.8286 80.7041 17.4093 74.2932 21.3959 68.0932C30.2764 65.5678 39.1586 63.0388 48.0391 60.5224C48.4738 60.4015 48.8653 60.2392 49.2278 60.0534C51.6685 63.6918 53.9071 67.4565 55.9563 71.3655C56.5516 72.5001 57.2262 73.0214 57.9369 73.1315C59.6182 74.2751 61.8513 74.5962 64.0593 73.2108C70.5677 69.1142 77.141 65.1006 83.653 61.0058C89.8024 57.1347 83.395 47.879 77.2528 51.7411Z",
    fill: "url(#paint0_linear_298_30676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6609 18.0466C18.5116 18.0466 22.4439 14.1143 22.4439 9.26353C22.4439 4.41278 18.5116 0.480469 13.6609 0.480469C8.81013 0.480469 4.87782 4.41278 4.87782 9.26353C4.87782 14.1143 8.81013 18.0466 13.6609 18.0466Z",
    fill: "url(#paint1_linear_298_30676)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30676",
    x1: 0.102051,
    y1: 45.4805,
    x2: 86.1476,
    y2: 45.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_30676",
    x1: 0.102051,
    y1: 45.4805,
    x2: 86.1476,
    y2: 45.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthlete);
export default __webpack_public_path__ + "static/media/athlete.b04b525b384d3cc532c463cd5b37fbb4.svg";
export { ForwardRef as ReactComponent };